<template>
	<div class="repair-country-wrap flex">
		<div class="country-left">
			<div class="country-left-title">全部</div>
			<ul class="country-left-ul">
				<li class="">
					<a class="active" href="javascript:void(0)"
						><i class="iconfont icon-file-text-o"></i>流程指引</a
					>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xfzn/" target="_blank"
						><i class="iconfont icon-file-text-o"></i>修复指南</a
					>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xcslwd/" target="_blank"
						><i class="iconfont icon-search"></i>现场受理网点</a
					>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/gyxxy/" target="_blank"
						><i class="iconfont icon-file-text-o"></i
						>公益性信用修复培训及报告</a
					>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/pxpt/" target="_blank"
						><i class="iconfont icon-file-text-o"></i
						>“信用中国”网站公益性在线培训平台</a
					>
				</li>
				<li class="">
					<a
						href="https://www.creditchina.gov.cn/xyxf/xfpxjgmd/"
						target="_blank"
						><i class="iconfont icon-search"></i>信用修复培训机构名单</a
					>
				</li>
				<li class="">
					<a
						href="https://www.creditchina.gov.cn/xyxf/xygbfwjgmd/"
						target="_blank"
						><i class="iconfont icon-search"></i>信用报告服务机构名单</a
					>
				</li>
				<li class="">
					<a
						href="https://public.creditchina.gov.cn/htmls/repair/repairSearch.html"
						target="_blank"
						><i class="iconfont icon-search"></i>修复进度自助查询</a
					>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/cjwd/" target="_blank"
						><i class="iconfont icon-file-text-o"></i>常见问答</a
					>
				</li>
			</ul>
		</div>

		<div class="country-right">
			<div class="right-box lczy" style="display: block">
				<div class="country-title">
					<img src="../../static/images/repair/3.png" />流程指引
				</div>
				<!-- <div class="country-right-image">
				<img src="@/static/images/repair/xyxf1.jpg" alt="">
			</div> -->
				<div class="lczyinfo">
					<!-- <strong>法人和非法人组织行政处罚信息信用修复流程指引</strong> -->
					<!-- <p>
            为引导失信主体规范、便捷办理信用修复，维护信用主体合法权益，根据《失信行为纠正后的信用信息修复管理办法（试行）》
            (国家发展改革委令第58号)相关规定，特制定本指引。
          </p> -->
					<!-- 2024/07/09修改流程指引的文字内容，替换为此时的信用中国对应文字图片：修复指引-->
				</div>
				<!-- <div class="lczyStep">
					<div style="display: flex">
						<div
							class="stepbox"
							v-bind:class="{ active: step1 }"
							@mouseover="instep1"
						>
							第一步
							<div v-bind:class="{ arrow: !step1, arrowActive: step1 }"></div>
						</div>
					</div>
					<div style="display: flex">
						<div
							class="stepbox"
							v-bind:class="{ active: step2 }"
							@mouseover="instep2"
						>
							第二步
							<div v-bind:class="{ arrow: !step2, arrowActive: step2 }"></div>
						</div>
					</div>
					<div style="display: flex">
						<div
							class="stepbox"
							v-bind:class="{ active: step3 }"
							@mouseover="instep3"
						>
							第三步
							<div v-bind:class="{ arrow: !step3, arrowActive: step3 }"></div>
						</div>
					</div>
					<div style="display: flex">
						<div
							class="stepbox"
							v-bind:class="{ active: step4 }"
							@mouseover="instep4"
						>
							第四步
							<div v-bind:class="{ arrow: !step4, arrowActive: step4 }"></div>
						</div>
					</div>
					<div style="display: flex">
						<div
							class="stepbox"
							v-bind:class="{ active: step5 }"
							@mouseover="instep5"
						>
							第五步
							<div v-bind:class="{ arrow: !step5, arrowActive: step5 }"></div>
						</div>
					</div>
				</div> -->

				<!-- <p class="clr"></p>
				<div class="lczystepcont lczystep-1" v-show="step1">
					<h3>查看行政处罚信息是否达到最短公示期</h3>
					<p class="small-t">
						<span>1</span>
						输入主体名称或者统一社会信用代码，并点击<em class="blue_text"
							>“搜索”</em
						>
						，找到主体。
					</p>
					<img src="../../static/images/repair/lczysetp-1-1.png" />
					<p class="small-t">
						<span>2</span>
						找到<em class="blue_text">“行政管理”</em> ，点击下方的<em
							class="blue_text"
							>“行政处罚”</em
						>
						分类，可以看到该主体的相关行政处罚信息。
					</p>
					<img src="../../static/images/repair/lczysetp-1-2.png" />
					<p class="small-t">
						<span>3</span>
						查看行政处罚信息右上角的<em class="blue_text">“在线申请修复”</em>
						按钮。
					</p>
					<dl>
						<dt>按钮为灰色，则表示未达到政策规定的最短公示期。</dt>
						<dt>
							按钮为红色，则表示已达到政策规定的最短公示期，具备信用信息修复申请条件。
						</dt>
					</dl>
				</div>

				<div class="lczystepcont lczystep-2" v-show="step2">
					<h3>准备相关材料</h3>
					<table border="0" cellpadding="0" cellspacing="0">
						<tr>
							<td>材料一：</td>
							<td>
								<p>
									《失信行为纠正后的信用信息修复业务办理授权委托书》或者《法定代表人身份证明书》
								</p>
							</td>
						</tr>
						<tr>
							<td>材料二：</td>
							<td>
								<p>
									市场监督管理领域的行政处罚由市场监督管理部门出具《准予信用修复决定书》或者其他准予信用修复的证明材料等；
								</p>
								<p>
									其他行政处罚由处罚机关出具《失信行为纠正后的信用信息修复申请表》，或者其他可说明相关责任义务已履行完毕的材料，如缴交罚款的收据、行政处罚机关出具的相关整改证明材料等；
								</p>
							</td>
						</tr>
						<tr>
							<td>材料三：</td>
							<td>
								<p>《失信行为纠正后的信用信息修复承诺书》</p>
							</td>
						</tr>
					</table>
					<dl class="cailiao">
						<dt>材料一</dt>
						<dd>
							<p style="border-bottom: 1px dashed #d9d9d9">
								失信行为纠正后的信用信息修复业务办理授权委托书.docx
								<a
									href="/static/repair/newcailiao1-1.docx"
									class="blue_text"
									download="失信行为纠正后的信用信息修复业务办理授权委托书.docx"
									>模板下载</a
								>
							</p>
						</dd>
						<dd>
							<p>
								法定代表人身份证明书.docx
								<small>
									(<em class="red_text">仅限</em>
									法定代表人申请行政处罚信息信用修复时使用)
								</small>
								<a
									href="/static/repair/newcailiao1-2.docx"
									class="blue_text"
									download="法定代表人身份证明书.docx"
									>模板下载</a
								>
							</p>
						</dd>
					</dl>
					<dl class="cailiao">
						<dt>材料二</dt>
						<dd>
							<p style="border-bottom: 1px dashed #d9d9d9">
								失信行为纠正后的信用信息修复申请表.docx
								<a
									href="/static/repair/newcailiao2-1.docx"
									class="blue_text"
									download="失信行为纠正后的信用信息修复申请表.docx"
									>模板下载</a
								>
							</p>
						</dd>
						<dd>
							<p>
								准予信用修复决定书.docx
								<small>
									(<em class="red_text">仅限</em>
									申请修复市场监督管理领域的行政处罚信息使用)
								</small>
								<a
									href="/static/repair/newcailiao2-2.docx"
									class="blue_text"
									download=" 准予信用修复决定书.docx"
									>模板下载</a
								>
							</p>
						</dd>
					</dl>
					<dl class="cailiao">
						<dt>材料三</dt>
						<dd>
							<p>
								失信行为纠正后的信用信息修复承诺书.docx
								<a
									href="/static/repair/newcailiao3.docx"
									class="blue_text"
									download="失信行为纠正后的信用信息修复业务办理授权委托书.docx"
									>模板下载</a
								>
							</p>
						</dd>
					</dl>
				</div>

				<div class="lczystepcont lczystep-3" v-show="step3">
					<h3>提交修复申请</h3>
					<p class="small-t">
						<span>1</span>
						点击<em class="blue_text">“在线申请修复”</em>
						按钮
					</p>
					<img src="../../static/images/repair/lczysetp-3-1.png" />
					<p class="small-t">
						<span>2</span>
						根据页面引导填报信息
					</p>
					<img src="../../static/images/repair/lczysetp-3-2.png" />
				</div>
				<div class="lczystepcont lczystep-4" v-show="step4">
					<h3>查看修复申请</h3>
					<p>
						可通过通知短信中的“办理进度查询码”在线查看受理情况、审核进度和审核结果
					</p>
					<p>
						查询地址:<a
							href="https://public.creditchina.gov.cn/htmls/repair3/repairSearch.html"
							style="color: #246bfb"
							>https://public.creditchina.gov.cn/htmls/repair3/repairSearch.html</a
						>
					</p>
					<img src="../../static/images/repair/lczysetp-4.png" />
				</div>
				<div class="lczystepcont lczystep-5" v-show="step5">
					<img src="../../static/images/repair/lczysetp-5.png" />
				</div> -->
				<!-- 2024/07/09修改流程指引的流程展示，替换为此时的信用中国对应的行政处罚、严重失信主题名单和其它失信信息三类信息-->
				<div class="menulist">
					<span v-bind:class="{ cur: fenlei1 }" @click="clickFenlei(1)"
						>行政处罚</span
					>
					<span v-bind:class="{ cur: fenlei2 }" @click="clickFenlei(2)"
						>严重失信主体名单</span
					>
					<span v-bind:class="{ cur: fenlei3 }" @click="clickFenlei(3)"
						>其他失信信息</span
					>
				</div>
				<div class="fenleiconts">
					<div class="fenleicont" v-show="fenlei1">
						<dl class="shouli">
							<dd>
								<strong>类型1：市场监管领域行政处罚信息</strong>
								<p>
									<span
										>信用修复申请受理单位：作出行政处罚决定的市场监督管理部门</span
									>
									政策法规依据：《市场监督管理信用修复管理办法》（国市监信规〔2021〕3号）<br />线上申请网址:<a
										href="https://www.gsxt.gov.cn"
										style="color: #246bfb"
									>
										https://www.gsxt.gov.cn</a
									>（ 登录后按照要求提交信用修复申请 ）
								</p>
							</dd>
							<dd>
								<strong>类型2：除市场监管领域以外，其他领域行政处罚信息</strong>
								<p>
									<span>信用修复申请受理单位：国家公共信用信息中心</span
									>政策法规依据：《失信行为纠正后的信用信息修复管理办法（试行）》（国家发展改革委令第58号）<br />线上申请网址:<a
										href="https://www.creditchina.gov.cn"
										style="color: #246bfb"
									>
										https://www.creditchina.gov.cn</a
									>（通过网站首页“信用信息”搜索框查询相关主体信息并选择对应行政处罚信息提交修复申请）
								</p>
							</dd>
							<dd>
								<p>
									<span
										>注:“信用中国”网站自收到各省级共享的市场监管领域行政处罚信息信用修复结果之日起三个工作日内同步修复；同时，“信用中国”网站行政处罚信息信用修复结果将每日向各省级市场监管部门共享。</span
									>
								</p>
							</dd>
						</dl>
					</div>

					<div class="fenleicont" v-show="fenlei2">
						<dl class="shouli">
							<dd>
								<strong>失信被执行人名单</strong>
								<p>
									<span>信用修复申请受理单位：作出列入决定的执行法院</span
									>政策法规依据：《最高人民法院关于公布失信被执行人名单信息的若干规定》
								</p>
							</dd>
							<dd>
								<strong>拖欠农民工工资失信联合惩戒对象名单</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的人力资源社会保障行政部门</span
									>政策法规依据：《拖欠农民工工资失信联合惩戒对象名单管理暂行办法》
								</p>
							</dd>
							<dd>
								<strong>重大税收违法失信主体名单</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的属地税务机关或税务局稽查局</span
									>
									政策法规依据：《重大税收违法失信主体信息公布管理办法》（国家税务局令第54号）
								</p>
							</dd>
							<dd>
								<strong>统计严重失信企业名单</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的国家统计局及其派出的调查机构、县级以上地方人民政府统计机构</span
									>
									政策法规依据：《统计严重失信企业信用管理办法》（国家统计局令第35号）
								</p>
							</dd>
							<dd>
								<strong>安全生产严重失信主体名单</strong>
								<p>
									<span>信用修复申请受理单位：作出列入决定的应急管理部门</span>
									政策法规依据：《安全生产严重失信主体名单管理办法》（应急管理部令第11号）
								</p>
							</dd>
							<dd>
								<strong>社会组织严重违法失信名单</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的属地社会组织登记管理机关（民政部门）</span
									>
									政策法规依据：《社会组织信用信息管理办法》第十七条
								</p>
							</dd>
							<dd>
								<strong>市场监督管理严重违法失信名单</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的市场监督管理部门</span
									>
									政策法规依据：《市场监督管理信用修复管理办法》（国市监信规〔2021〕3号）<br />
									线上申请网址:<a
										href="https://www.gsxt.gov.cn"
										style="color: #246bfb"
									>
										https://www.gsxt.gov.cn</a
									>（ 登录后按照要求提交信用修复申请 ）
								</p>
							</dd>
							<dd>
								<p>
									<span
										>注：“信用中国”网站自收到认定单位共享的移出名单之日起三个工作日内终止公示严重失信主体名单信息。</span
									>
								</p>
							</dd>
						</dl>
					</div>
					<div class="fenleicont" v-show="fenlei3">
						<dl class="shouli">
							<dd>
								<strong>社会组织活动异常名录</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定的属地社会组织登记管理机关（民政部门）</span
									>
									政策法规依据：《社会组织信用信息管理办法》第十七条
								</p>
							</dd>
							<dd>
								<strong>企业经营异常名录</strong>
								<p>
									<span
										>信用修复申请受理单位：作出列入决定（作出标记）的市场监督管理部门</span
									>
									政策法规依据：《市场监督管理信用修复管理办法》（国市监信规〔2021〕3号）<br />
									线上申请网址:<a
										href="https://www.gsxt.gov.cn"
										style="color: #246bfb"
									>
										https://www.gsxt.gov.cn</a
									>（ 登录后按照要求提交信用修复申请 ）
								</p>
							</dd>
							<dd>
								<p>
									<span
										>注：“信用中国”网站自收到认定单位共享的移出名单之日起三个工作日内终止公示相关失信信息。</span
									>
								</p>
							</dd>
						</dl>
					</div>
				</div>
				<!-- <div class="country-title">
          <img src="../../static/images/repair/3.png" />材料清单及说明
        </div>
        <process routeName="country" /> -->
			</div>
		</div>
	</div>
</template>

<script>
	import process from "@/components/process";
	export default {
		components: {
			process,
		},
		data() {
			return {
				// step1: true,
				// step2: false,
				// step3: false,
				// step4: false,
				// step5: false,
				fenlei1: true,
				fenlei2: false,
				fenlei3: false,
			};
		},
		created() {},
		mounted() {},
		methods: {
			// instep1() {
			// 	this.step1 = true;
			// 	this.step2 = false;
			// 	this.step3 = false;
			// 	this.step4 = false;
			// 	this.step5 = false;
			// },
			// instep2() {
			// 	this.step1 = false;
			// 	this.step2 = true;
			// 	this.step3 = false;
			// 	this.step4 = false;
			// 	this.step5 = false;
			// },
			// instep3() {
			// 	this.step1 = false;
			// 	this.step2 = false;
			// 	this.step3 = true;
			// 	this.step4 = false;
			// 	this.step5 = false;
			// },
			// instep4() {
			// 	this.step1 = false;
			// 	this.step2 = false;
			// 	this.step3 = false;
			// 	this.step4 = true;
			// 	this.step5 = false;
			// },
			// instep5() {
			// 	this.step1 = false;
			// 	this.step2 = false;
			// 	this.step3 = false;
			// 	this.step4 = false;
			// 	this.step5 = true;
			// },
			clickFenlei(index) {
				// console.log(index);
				switch (index) {
					case 1:
						this.fenlei1 = true;
						this.fenlei2 = false;
						this.fenlei3 = false;
						break;

					case 2:
						this.fenlei1 = false;
						this.fenlei2 = true;
						this.fenlei3 = false;
						break;
					case 3:
						this.fenlei1 = false;
						this.fenlei2 = false;
						this.fenlei3 = true;
						break;
				}
			},
		},

		computed: {},
		watch: {},
	};
</script>
<style lang="scss" scoped>
	.repair-country-wrap {
		width: 100%;
		align-items: flex-start;

		.country-left {
			width: 180px;
			flex-shrink: 0;
			font-size: 14px;
			padding: 0;
			margin-top: 46px;
			.country-left-title {
				font-size: 20px;
				font-weight: normal;
				border-bottom: 1px solid #dddddd;
				padding-bottom: 12px;
			}
			.country-left-ul {
				li {
					list-style: none;
					padding: 17px 0 17px 25px;
					border-bottom: 1px solid #dddddd;
					cursor: pointer;
					a {
						letter-spacing: 1px;
						color: #333;
						&.active {
							color: #e22323;
						}
						i.iconfont {
							font-size: 14px;
							display: inline-block;
							margin-right: 8px;
						}
					}
				}
			}
		}
		.country-right {
			width: calc(100% - 180px);
			padding-left: 36px;
			box-sizing: border-box;
			overflow: hidden;
			margin-top: 22px;

			.country-title {
				font-size: 15px;
				line-height: 53px;
				color: #333;
				img {
					vertical-align: middle;
					width: 8px;
					margin-right: 10px;
				}
			}
			.lczyinfo {
				// background: url(../../static/images/repair/lczybg2023.png) left top
				//   no-repeat;
				background: url(../../static/images/repair/xfzybanner.png) left top
					no-repeat;
				background-size: 100%;
				height: 125px;
				padding: 25px;
				color: #fff;
				overflow: hidden;
				position: relative;
			}
			.lczyinfo strong {
				font-weight: bold;
				font-size: 24px;
				text-align: center;
				display: block;
				margin-top: 10px;
			}
			.lczyinfo p {
				font-size: 16px;
				line-height: 28px;
				margin-top: 12px;
				text-indent: 2em;
				text-align: justify;
			}
		}
	}
	.right-box {
		display: none;
	}
	.menulist {
		display: flex;
		justify-content: space-between;
		margin-top: 30px;
	}
	.menulist span {
		font-size: 20px;
		text-align: center;
		width: 300px;
		height: 60px;
		line-height: 60px;
		border: 1px solid #c8d9f0;
		background: #f3f8ff;
		cursor: pointer;
	}
	.menulist span.cur {
		background: #e22323;
		color: #fff;
	}
	.fenleiconts {
		box-sizing: border-box;
		.fenleicont {
			.shouli {
				margin-top: 30px;
				line-height: 32px;
				margin-bottom: 10px;
				dd {
					padding: 0;
					text-indent: 0;
					margin-top: 25px;
					font-size: 14px;
					strong {
						display: block;
						background: url(../../static/images/repair/shouliicon.png) left
							center no-repeat;
						height: 30px;
						line-height: 30px;
						padding-left: 14px;
						font-size: 18px;
						margin: 0 0 10px;
					}
					p {
						background: #edf1f4;
						padding: 15px;
						font-size: 16px;
						line-height: 30px;
						margin-top: 0;
						span {
							display: block;
							color: #e22323;
						}
					}
				}
			}
		}
	}

	.lczyStep .active {
		background: linear-gradient(
			90deg,
			rgba(226, 35, 35, 1) 0%,
			rgba(198, 18, 18, 1) 100%
		);
		color: #fff;
		border: 0;
	}
	.lczystepcont {
		border: 1px solid #e22323;
		padding: 30px;
		margin-top: 38px;
		position: relative;
	}
	.lczystepcont:after {
		content: "";
		position: absolute;
		left: 60px;
		top: -17px;
		width: 37px;
		height: 18px;
		background: url("../../static/images/repair/lczystepcontarr.jpg") left top
			no-repeat;
	}
	.lczystepcont.lczystep-2:after {
		left: 280px;
	}

	.lczystepcont.lczystep-3:after {
		left: 500px;
	}

	.lczystepcont.lczystep-4:after {
		left: 720px;
	}

	.lczystepcont.lczystep-5:after {
		left: 960px;
	}

	.lczystepcont.lczystep-5 {
		text-align: center;
		padding: 50px;
	}

	.lczystepcont h3 {
		display: inline-block;
		font-size: 20px;
		color: #e22323;
		font-weight: bold;
		position: relative;
	}

	.lczystepcont h3:after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		height: 8px;
		width: 100%;
		background: rgba(226, 35, 35, 0.2);
	}

	.lczystepcont p {
		font-size: 16px;
		line-height: 28px;
		margin-top: 10px;
	}

	.lczystepcont p.small-t {
		margin-top: 30px;
		font-size: 18px;
		line-height: 28px;
	}

	.lczystepcont p.small-t span {
		display: inline-block;
		width: 26px;
		height: 26px;
		background: #e22323;
		border-radius: 50%;
		color: #fff;
		font-size: 14px;
		text-align: center;
		line-height: 26px;
		margin-right: 15px;
	}
	.lczystepcont p.small-t em.blue_text {
		color: #246bfb;
		font-style: normal;
		font-weight: normal;
	}
	.lczystepcont table {
		width: 100%;
	}

	.lczystepcont table tr td:nth-child(1) {
		width: 8%;
	}

	.lczystepcont .cailiao dt {
		background: #e22323;
		display: inline-block;
		padding: 0 30px;
		font-size: 16px;
		color: #fff;
		height: 30px;
		line-height: 30px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	.lczystepcont .cailiao dd {
		background: #ffffff;
		font-size: 16px;
		padding: 0 20px;
	}

	.lczystepcont .cailiao dd p {
		margin: 0;
		font-size: 16px;
		height: 65px;
		line-height: 65px;
		text-indent: 0;
	}

	.lczystepcont .cailiao dd p small {
		display: inline-block;
		margin-left: 30px;
		font-size: 12px;
	}

	.lczystepcont .cailiao dd p small em.red_text {
		color: #e22323;
		font-style: normal;
		font-weight: normal;
	}

	.lczystepcont .cailiao dd p a.blue_text {
		float: right;
		color: #246bfb;
		background: url("../../static/images/repair/lczydownload.png") left center
			no-repeat;
		padding-left: 25px;
		font-size: 14px;
	}
	.lczy .lczystepcont img {
		width: 100%;
		margin: 20px 0 0;
	}
	.lczy .lczystepcont td {
		padding: 0;
		font-size: 16px;
		line-height: 28px;
		vertical-align: top;
		padding: 10px 0;
	}

	.lczy .lczystepcont td p {
		margin: 0;
		font-size: 16px;
		line-height: 28px;
	}

	.lczy .lczystepcont tr:nth-child(odd) {
		background: none;
	}
</style>
<style lang="scss" scoped>
	.lczyStep {
		display: flex;
		margin-top: 30px;
		overflow: hidden;
	}
	.stepbox {
		position: relative;
		float: left;
		width: 172px;
		height: 60px;
		border: 1px solid #000;
		border-radius: 4px;
		text-align: center;
		line-height: 60px;
		font-size: 18px;
		margin-right: 50px;
	}
	.stepbox .arrow {
		content: "";
		position: absolute;
		right: -35px;
		top: 22px;
		width: 16px;
		height: 16px;
		background: url("../../static/images/repair/lczysteparr.png") left top
			no-repeat;
	}
	.stepbox .arrowActive {
		content: "";
		position: absolute;
		right: -35px;
		top: 22px;
		width: 16px;
		height: 16px;
		background: url("../../static/images/repair/lczysteparr-hover.png") left top
			no-repeat;
	}
</style>
